import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './containers/header/header';
import Home from './pages/home/index';
import Project from './pages/project';
import Error from './pages/error';
import Footer from './containers/footer/footer';
import LikeSection from './components/likesection/LikeSection';
import './main.scss';

function App() {
  useEffect(() => {
    const handleAnchorClick = (e) => {
      const target = e.target.closest('a');
      if (
        target &&
        target.hash &&
        (target.pathname === window.location.pathname || target.pathname === '/')
      ) {
        const id = target.hash.slice(1);
        const element = document.getElementById(id);
        if (element) {
          e.preventDefault();
          const targetY = element.getBoundingClientRect().top + window.pageYOffset - 80;

          window.scrollTo({
            top: targetY,
            behavior: 'smooth',
          });

          // Mettre à jour l'URL sans provoquer de saut
          window.history.pushState(null, '', target.hash);
        }
      }
    };

    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);

  return (
    <div>
      <input type="checkbox" id="theme-switch" style={{ display: 'none' }} />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects/:id" element={<Project />} />
        <Route path="/*" element={<Error />} />
      </Routes>
      <LikeSection />
      <Footer />
    </div>
  );
}

export default App;
